import React from 'react'

const Pen = () => (
  <svg width='25px' height='25px' viewBox='0 0 64 64'>
    <g id='PEN_1_'>
      <g id='PEN'>
        <g>
        <path className='project-header__icon'
        d="M12.938,42.498l8.446,8.429l25.339-25.288l-8.447-8.429L12.938,42.498z M7.998,55.84l11.258-2.806l-8.447-8.431
				L7.998,55.84z M55.167,12.996l-4.224-4.215c-1.166-1.164-3.057-1.164-4.223,0l-6.334,6.322l8.446,8.429l6.334-6.322
				C56.333,16.046,56.333,14.159,55.167,12.996z"/>
        </g>
      </g>
    </g>
  </svg>
)

export default Pen



// WEBPACK FOOTER //
// ./src/components/ProjectHeader/Pen.js